<template>
	<div class="form form-horizontal form-scrollable">
		<div class="modal-body">
			<div class="form-row">
				<!-- NOMBRE -->
				<div class="form-group col-md-12">
					<label class="col-form-label label-modal" for="name">Nombre</label>
					<input autocomplete="off" v-model="benefit_type.name" type="text" name="name" class="form-control form-control-sm" v-validate="'required'" data-vv-as="'Nombre'" />
					<span v-show="errors.has('name')" class="form-group__error"> <i class="fas fa-exclamation-circle"></i> {{ errors.first('name') }} </span>
					<ErrorBackendComponent :errorsBackend="errorsBackend" name="benefit_type.name" />
					<ErrorBackendComponent :errorsBackend="errorsBackend" name="benefit_type" />
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button @click="mtd_send" class="btn btn-sm btn-primary mr-3">{{ propInfo.data.buttonSubmit }}</button>
			<button class="btn btn-sm btn-secondary" @click="mtd_close">Cancelar</button>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	props: {
		propInfo: {
			required: true,
		},
	},
	components: {},
	data() {
		return {
			benefit_type: {
				id: null,
				name: null,
			},
			enterprises: [],
			errorsBackend: {},
			methods: {
				init: {
					create: 'this.mtd_onCreate()',
					edit: 'this.mtd_onEdit()',
				},
				action: {
					create: 'this.mtd_store()',
					edit: 'this.mtd_update()',
				},
			},
		};
	},
	computed: {
		...mapGetters(['url_api']),
		cpd_btnDisabled() {
			return this.errors.any();
		},
	},
	mounted() {
		eval(this.methods.init[this.propInfo.data.method]);
	},
	methods: {
		...mapActions(['get', 'post', 'update']),
		mtd_onCreate: function () {
			this.$emit('onload', { status: 'success' });
		},
		mtd_onEdit: function () {
			this.mtd_setData(this.propInfo.data.row);
			this.$emit('onload', { status: 'success' });
		},
		mtd_store: function () {
			this.post({ url: `${this.url_api}/benefit_types`, params: { benefit_type: this.benefit_type } })
				.then(res => {
					this.$emit('success', { component: this.propInfo.component, res: { benefit_type: res.benefit_type }, action: 'store' });
					window.message('success', 'Registro exitoso');
				})
				.catch(errors => (this.errorsBackend = errors));
		},
		mtd_update: function () {
			this.update({ url: `${this.url_api}/benefit_types/${this.benefit_type.id}`, params: { benefit_type: this.benefit_type } })
				.then(res => {
					this.$emit('success', { component: this.propInfo.component, res: { benefit_type: res.benefit_type }, action: 'update' });
					window.message('success', 'Actualización exitosa');
				})
				.catch(errors => (this.errorsBackend = errors));
		},
		mtd_setData(resource) {
			this.benefit_type.id = resource.id;
			this.benefit_type.name = resource.name;
		},
		$eval(expr) {
			return eval(expr);
		},
		mtd_close: function () {
			this.$emit('close');
		},
		mtd_send: function () {
			this.submitted = true;
			var _this = this;
			this.$validator.validate().then(valid => {
				if (valid) {
					_this.$eval(_this.methods.action[this.propInfo.data.method]);
				}
			});
		},
	},
};
</script>
